export var uriEncode = function uriEncode(value) {
  return encodeURIComponent(value).replace(/[!*'()]/g, function (c) {
    return "%".concat(c.charCodeAt(0).toString(16).toUpperCase());
  });
};